module.exports = __webpack_public_path__ + "static/media/01.70e0b8ee.png";